// @flow
import type { ID_TYPE } from '../../types/common';
import type { OMNISEARCH_RESPONSE_TYPE } from '../../types/omnisearch';
import {
  OMNISEARCH_ROUTE_TYPE,
  OMNISEARCH_STUDENT_TYPE,
  OMNISEARCH_MONITOR_TYPE,
  OMNISEARCH_PARENT_TYPE,
  OMNISEARCH_DRIVER_TYPE,
  OMNISEARCH_BUS_TYPE, OMNISEARCH_ROUTE_STOP_TYPE,
} from '../../types/omnisearch';
import { Omnisearch } from '../../api';

const transformOmnisearchResults = (response: OMNISEARCH_RESPONSE_TYPE) => (
  response.results.map((result) => {
    const newResult = {
      ...result,
      value: `${result.result_type}${result.id}`,
      textIndex: result.text,
    };

    switch (result.result_type) {
      case OMNISEARCH_ROUTE_TYPE: {
        return {
          ...newResult,
          label: result.name,
          group_type: 'route',
          target_role: 'route',
          base_model_id: newResult.id,
        };
      }

      case OMNISEARCH_ROUTE_STOP_TYPE: {
        return {
          ...newResult,
          label: result.name,
          group_type: 'route_stop',
          target_role: 'route_stop',
          base_model_id: newResult.id,
        };
      }
      case OMNISEARCH_STUDENT_TYPE:
        return {
          ...newResult,
          label: result.first_name,
          group_type: 'user',
          target_role: 'user',
          base_model_id: newResult.user_id,
        };
      case OMNISEARCH_MONITOR_TYPE:
        return {
          ...newResult,
          label: result.first_name,
          group_type: 'user',
          target_role: 'user',
          base_model_id: newResult.user_id,
        };
      case OMNISEARCH_PARENT_TYPE:
        return {
          ...newResult,
          label: result.first_name,
          group_type: 'user',
          target_role: 'user',
          base_model_id: newResult.user_id,
        };
      case OMNISEARCH_DRIVER_TYPE: {
        return {
          ...newResult,
          label: result.first_name,
          group_type: 'user',
          target_role: 'user',
          base_model_id: newResult.id,
        };
      }
      case OMNISEARCH_BUS_TYPE: {
        return {
          ...newResult,
          label: result.plates,
          group_type: 'bus',
          target_role: 'bus',
          base_model_id: newResult.id,
        };
      }
      default: {
        return {
          ...newResult,
          label: result.text,
        };
      }
    }
  })
);

export const generateFetcher = (
  resultType?: string,
  schoolId: ID_TYPE,
  token: string,
  extraOptions?: any = {},
) => (searchText: string) => {
  const filters = {
    text: searchText,
    school: schoolId,
    result_type: resultType,
  };
  if (extraOptions.short_name){
    delete filters.text;
    filters.short_name = searchText;
  }
  return Omnisearch.custom.search({
    token,
    filters,
  }).then(transformOmnisearchResults);
};



// WEBPACK FOOTER //
// ./src/scripts/components/Omnisearch/utils.js